
import store from "@/store";

const audio = new Audio("/static/sounds/notifySound.wav");

audio.volume = 0.5;

class WebSocketService {
    
    constructor() {
        this.socket = null;
        this.token = null;

        this.connected = false;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = Infinity;
        this.reconnectDelay = 3000;

        this.listeners = {};
    }

    connect(token, companyId) {
        if (this.socket &&
            (this.socket.readyState === WebSocket.OPEN ||
            this.socket.readyState === WebSocket.CONNECTING)) {
            return;
        }

        this.token = token;
        this.companyId = companyId;

        const protocol = window.location.protocol === "https:" ? "wss" : "ws";

        this.socket = new WebSocket(
            `${protocol}://${window.location.host}/ws/notifications/?kpl=${token}&kamb=${companyId}`
        );

        this.socket.onopen = () => {
            console.log("✅ WebSocket Connected");
            store.dispatch("notifications/setConnected",true);
        };

        this.socket.onmessage = (event) => {
            const notification = JSON.parse(event.data);

            store.dispatch("notifications/addNotification",notification);
            audio.currentTime = 0;
            audio.play().catch(err => {
                console.log("Unable to play notification sound:", err);
            });
        };

        this.socket.onclose = () => {
            console.log("Disconnected");

            store.dispatch("notifications/setConnected",false);
            if (!this.token) {
                console.warn("Cannot reconnect PaymentSocket: missing credentials");
                return;
            }

            setTimeout(() => {
                this.connect(this.token,this.companyId);
            }, 3000);
        };

        this.socket.onerror = (err) => {
            console.error(err);
        };
    }

    reconnect() {

        if (this.reconnectAttempts >= this.maxReconnectAttempts) {

            console.log("Reconnect limit reached.");

            return;

        }

        this.reconnectAttempts++;

        console.log(
            `Reconnect attempt ${this.reconnectAttempts}...`
        );

        setTimeout(() => {

            this.connect(this.token);

        }, this.reconnectDelay);

    }

    disconnect() {

        if (!this.socket) return;

        this.reconnectAttempts = this.maxReconnectAttempts;

        this.socket.close();

        this.socket = null;

        this.connected = false;
    }

    send(data) {

        if (!this.connected) {

            console.warn("WebSocket not connected.");

            return;

        }

        this.socket.send(JSON.stringify(data));

    }

    on(event, callback) {

        if (!this.listeners[event]) {

            this.listeners[event] = [];

        }

        this.listeners[event].push(callback);

    }

    off(event, callback) {

        if (!this.listeners[event]) return;

        this.listeners[event] =
            this.listeners[event].filter(fn => fn !== callback);

    }

    emit(event, payload = null) {

        if (!this.listeners[event]) return;

        this.listeners[event].forEach(callback => {

            callback(payload);

        });

    }

    isConnected() {

        return this.connected;

    }

}
const websocket = new WebSocketService();

export default {
    install(app) {
        app.config.globalProperties.$ws = websocket;
    }
}

export { websocket };
